import React, {useEffect, useState} from 'react';
import {FormattedMessage, useIntl} from 'react-intl';
import {DraggableCard} from "../components/DraggableCard";
import {DnDItemTypes, useLocalDrop} from '../basic/Utilities';
import {useDrop} from "react-dnd";

const setCardSpaces = (groupId, num, cards, onCardSelected, allowedActions, spaceName, onZoom, activeCard, onToggleActiveCard, onToggleCardSide) => {
    const spaces = [];

    for(let s = 0; s < num; s++) {
        spaces.push(
            <OneCardSpace
                cards={cards}
                spaceId={s + '_' + groupId}
                key={s + '_' + groupId}
                onCardSelected={onCardSelected}
                allowedActions={allowedActions}
                spaceName={spaceName}
                onZoom = {onZoom}
                activeCard = {activeCard}
                onToggleActiveCard = {onToggleActiveCard}
                onToggleCardSide={onToggleCardSide}
            />
        );
    }
    return spaces;
};

const renderCards = (cards, allowedActions, onZoom, activeCard, onToggleActiveCard, onToggleCardSide, leftAuto) => {
    let cardsOut = [];

    for(let i = 0; i < cards.length; i++){
        cardsOut.push(
            <DraggableCard
                id = {cards[i].id}
                isActive = {activeCard === cards[i].key}
                open = {cards[i].open}
                top = {cards[i].top}
                left = {leftAuto ? 'auto' : cards[i].left}
                zIndex = {cards[i].index}
                allowedActions = {allowedActions}
                itemKey = {cards[i].key}
                key = {i}
                onZoom = {onZoom}
                onToggleActive={onToggleActiveCard}
                onToggleSide={onToggleCardSide}
            />
        );
    }

    return cardsOut;
};

const OneCardSpace = ({spaceId, cards, onCardSelected, allowedActions, spaceName, onZoom, activeCard, onToggleActiveCard, onToggleCardSide}) => {
    const [card, setCard] = useState({});
    const [, toggleCardOpen] = useState(true);
    const spaceNameId = spaceName + spaceId;

    useEffect(() => {
        setCard(cards.filter((item) => item.place === spaceNameId));
    },[cards, spaceNameId]);

    const [{ isOverCurrent }, drop] = useDrop({
        accept: DnDItemTypes.CARD,
        drop(item, monitor) {
            toggleCardOpen(item.open);
            onCardSelected(spaceNameId, item.id, item.itemKey);
        },
        canDrop(item) {
            return card.length === 0 && item.open;
        },
        collect: (monitor) => ({
            isOverCurrent: monitor.isOver({ shallow: true }),
        }),
    });

    return (
        <div className={isOverCurrent ? "over card-space" : "card-space"} id={spaceNameId} ref={drop}>
            {renderCards(card, allowedActions, onZoom, activeCard, onToggleActiveCard, onToggleCardSide)}
        </div>
    );
};

const GetRandomCard = ({btnText, cards, onCardSelected, onCardZoom, activeCard, onToggleActiveCard, onToggleCardSide, reset}) => {
    const [randomCard, setRandomCard] = useState (undefined);
    const availableCards = cards.filter((item) => item.place === "cardsTable");

    useEffect(() => {
        if(reset) {
            setRandomCard(undefined);
        }
    }, [setRandomCard, reset]);


    return (
        !randomCard ? (
            <button
                className="btn btn-primary"
                type="button"
                onClick={()=>{
                    const cardItem = availableCards[Math.floor(Math.random() * availableCards.length)];
                    setRandomCard(cardItem);
                    onCardSelected("cardSpecialSelection", cardItem.id, cardItem.key);
                }}
            >
                <FormattedMessage id={btnText} />
            </button>
        ) : (
            renderCards(
                [randomCard],
                {
                    zoom: true,
                    turn: false,
                    },
                onCardZoom,
                activeCard,
                onToggleActiveCard,
                onToggleCardSide,
                true
            )
        )
    );
};

const NameField = ({index}) => {
    const [name, setName] = useState ("");
    const { formatMessage } = useIntl();

    const handleOnNameChange = (e) => {
        setName(e.target.value);
    };

    return (
        <input className="user-name" type="text" name={"name" + index} value={name} onChange={handleOnNameChange} placeholder={formatMessage({ id: "cardSelection.nameInput.placeholder" })} />
    );
};

const SelectionPartyArea = ({index, partyItem, height, allowedActions, config, cards, onCardSelected, onCardZoom, activeCard, onToggleActiveCard, onToggleCardSide, reset}) => {
    const { title, titleB, defaultSpaces, specialSpaces, specialInfo, specialAction, parties, defaultSpacesB } = config;
    const selectedCards = cards.filter((item) => item.place !== "cardsTable");
    const [open, toggleOpen] = useState(index === 0 );
    let defaultSpacesData = defaultSpacesB ? [{title: title, spaces: defaultSpaces, spaceName: "cardSelection"}, {title: titleB, spaces: defaultSpacesB, spaceName: "cardSelectionB"}] : [{title: title, spaces: defaultSpaces, spaceName: "cardSelection"}];
    defaultSpacesData = ((index > 0 && index % 2 !== 0) && defaultSpacesData.length > 1) ? defaultSpacesData.reverse() : defaultSpacesData;
    return (
        <div className={"selection-party " + (open ? 'active' : 'closed')}>
            {parties.length > 1 &&
            <div className="header">
                <button className={"btn btn-tab toggle-player-btn " + (open ? "icon-hide-white" : "icon-show-white")} onClick={() => {toggleOpen(!open)}}>
                    <FormattedMessage
                        id="cardSelection.playerToggle.btn"
                        values={{
                            party: partyItem.title,
                            state: (open ? <FormattedMessage id="area.state.hide"/> : <FormattedMessage id="area.state.show" />)
                            }}
                    />
                </button>
                <NameField index={index} />
            </div>
            }
            <div className="body" style={height && open ? {height} : {}}>
                { defaultSpacesData.map(( data, i )  => (
                    <div className="default-spaces" key={i}>
                        <div className="help-title"><FormattedMessage id={data.title} values={data.spaces && {num: data.spaces}} /></div>
                        {data.spaces ? (
                            <div className="card-spaces">
                                {
                                    setCardSpaces(
                                        'selection2'+partyItem.title,
                                        data.spaces,
                                        selectedCards,
                                        onCardSelected,
                                        allowedActions,
                                        data.spaceName,
                                        onCardZoom,
                                        activeCard,
                                        onToggleActiveCard,
                                        onToggleCardSide
                                    )
                                }
                            </div>
                        ):(
                            renderCards(selectedCards, allowedActions, onCardZoom, activeCard, onToggleActiveCard, onToggleCardSide)
                        )}
                    </div>
                ))}

                {specialSpaces && (
                    <div className="special-spaces">
                        <div className="help-title"><FormattedMessage id={specialInfo} /></div>
                        <div className="card-spaces">
                            {
                                specialAction ? (
                                    <GetRandomCard
                                        btnText={specialAction.btnText}
                                        cards={cards}
                                        activeCard={activeCard}
                                        onCardSelected={onCardSelected}
                                        onCardZoom={onCardZoom}
                                        onToggleActiveCard={onToggleActiveCard}
                                        onToggleCardSide={onToggleCardSide}
                                        reset={reset}
                                    />
                                ) : (
                                    setCardSpaces(
                                        'selection3'+partyItem.title,
                                        specialSpaces,
                                        selectedCards,
                                        onCardSelected,
                                        allowedActions,
                                        "cardSpecialSelection",
                                        onCardZoom,
                                        activeCard,
                                        onToggleActiveCard,
                                        onToggleCardSide
                                    )
                                )
                            }
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};


export const CardsSelection = ({id, className, height, allowedActions, config, cards, onCardMove, onCardSelected, onCardZoom, activeCard, onToggleActiveCard, onToggleCardSide, reset}) => {
    const { defaultSpaces, parties } = config;
    const ref = useLocalDrop(onCardMove, id);

    const [, dummyRef] = useDrop({
        accept: DnDItemTypes.CARD,
        canDrop() {
            return false;
        },
    });

    return (
        <div
            className={className + (parties.length > 1 ? ' multiPlayer' : '')}
            id={id}
            ref={defaultSpaces ? dummyRef : ref}
        >

            { parties.map((item, index) => (
                <SelectionPartyArea
                    key={index}
                    index={index}
                    partyItem={item}
                    height={height}
                    allowedActions={allowedActions}
                    config={config}
                    cards={cards}
                    onCardSelected={onCardSelected}
                    onCardZoom={onCardZoom}
                    activeCard={activeCard}
                    onToggleActiveCard={onToggleActiveCard}
                    onToggleCardSide={onToggleCardSide}
                    reset={reset}
                />
            ))}

        </div>
    );
};